import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing an BookOnline icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <BookOnlineIcon width={24} />
 */
const BookOnlineIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15V13C8.28333
            13 8.52083 12.9042 8.7125 12.7125C8.90417 12.5208 9 12.2833 9 12C9 11.7167 8.90417 11.4792
            8.7125 11.2875C8.52083 11.0958 8.28333 11 8 11V9C8 8.71667 8.09583 8.47917 8.2875 8.2875C8.47917
            8.09583 8.71667 8 9 8H15C15.2833 8 15.5208 8.09583 15.7125 8.2875C15.9042 8.47917 16 8.71667 16
            9V11C15.7167 11 15.4792 11.0958 15.2875 11.2875C15.0958 11.4792 15 11.7167 15 12C15 12.2833 15.0958
            12.5208 15.2875 12.7125C15.4792 12.9042 15.7167 13 16 13V15C16 15.2833 15.9042 15.5208 15.7125
            15.7125C15.5208 15.9042 15.2833 16 15 16H9ZM12 14.5C12.1333 14.5 12.25 14.45 12.35 14.35C12.45 14.25
            12.5 14.1333 12.5 14C12.5 13.8667 12.45 13.75 12.35 13.65C12.25 13.55 12.1333 13.5 12 13.5C11.8667
            13.5 11.75 13.55 11.65 13.65C11.55 13.75 11.5 13.8667 11.5 14C11.5 14.1333 11.55 14.25 11.65
            14.35C11.75 14.45 11.8667 14.5 12 14.5ZM12 12.5C12.1333 12.5 12.25 12.45 12.35 12.35C12.45 12.25
            12.5 12.1333 12.5 12C12.5 11.8667 12.45 11.75 12.35 11.65C12.25 11.55 12.1333 11.5 12 11.5C11.8667
            11.5 11.75 11.55 11.65 11.65C11.55 11.75 11.5 11.8667 11.5 12C11.5 12.1333 11.55 12.25 11.65
            12.35C11.75 12.45 11.8667 12.5 12 12.5ZM12 10.5C12.1333 10.5 12.25 10.45 12.35 10.35C12.45 10.25
            12.5 10.1333 12.5 10C12.5 9.86667 12.45 9.75 12.35 9.65C12.25 9.55 12.1333 9.5 12 9.5C11.8667 9.5
            11.75 9.55 11.65 9.65C11.55 9.75 11.5 9.86667 11.5 10C11.5 10.1333 11.55 10.25 11.65 10.35C11.75
            10.45 11.8667 10.5 12 10.5ZM7 23C6.45 23 5.97917 22.8042 5.5875 22.4125C5.19583 22.0208 5 21.55 5
            21V3C5 2.45 5.19583 1.97917 5.5875 1.5875C5.97917 1.19583 6.45 1 7 1H17C17.55 1 18.0208 1.19583
            18.4125 1.5875C18.8042 1.97917 19 2.45 19 3V21C19 21.55 18.8042 22.0208 18.4125 22.4125C18.0208
            22.8042 17.55 23 17 23H7ZM7 18H17V6H7V18Z`}
        />
    </SvgIcon>
)

BookOnlineIcon.defaultProps = defaultProps

export { BookOnlineIcon }
